import React, { Component } from 'react';
import { Form } from 'redux-form';
import PropTypes from 'prop-types';
import PhoneForm from '../../../components/PhoneForm/PhoneForm';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DateOfBirth from '../../../components/DateOfBirth/DateOfBirth';
import SSN from '../../../components/SSN/SSN';
import SelfReportedIncomeGroup from '../../../components/SelfReportedIncomeGroup/SelfReportedIncomeGroup';
import _ from 'lodash';
import { getInitialFormValues } from '../../../config/form';

const FAST_APPLY = 'FAST';

export class PersonalInformationForm extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        onSubmit: PropTypes.func.isRequired,
        showPhone: PropTypes.bool,
        showSelfReportedIncome: PropTypes.bool
    };

    render() {
        const { onSubmit, showPhone, showSelfReportedIncome } = this.props;

        return (
            <Form id="personal-info-form" onSubmit={onSubmit} autoComplete="off">
                <DateOfBirth />
                <SSN />
                {showPhone && <PhoneForm />}
                {showSelfReportedIncome && <SelfReportedIncomeGroup />}
            </Form>
        );
    }
}

export const mapStateToProps = state => {
    let showPhone = true;
    let showSelfReportedIncome = true;

    if (_.get(state, 'serverData.applyType') === FAST_APPLY) {
        showPhone = false;
        showSelfReportedIncome = false;
    }

    return {
        showPhone,
        showSelfReportedIncome
    };
};
export default connect(mapStateToProps)(injectIntl(
    (PersonalInformationForm)
));
